export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtRabatsk';
export const NAME = 'RabatovaSkupina';
